<template>
    <div class="header">
        <div class="navBar">
            <span :class="drawShow ? 'open' : 'close'"><i class="iconfont tsa-icon-mobile-memu" @click="changeShow"></i></span>
            <!-- <img :src="drawShow ? navMenuCheck : navSrc" :class="drawShow ? 'open' : 'close'" @click="changeShow"/> -->
        </div>
        <h1 class="logo">
            <img src="https://tsa-content.oss-cn-beijing.aliyuncs.com/logo/ipr_whole_dark_logo.png" @click="$router.push({path:'/'})">
        </h1>
        <!-- <div class="share" @click="copy" :data-clipboard-text="iprUrl">
            <img src="@/assets/img/share.png" alt="">
        </div> -->
        <van-popup v-model="drawShow" position="left" :get-container="getContainer" overlay-class="navOverlay" class="navSlide">
            <div class="sildeMenu">
                <div class="menu">
                    <div class="menu-item" :class="{'active':($route.path===item.link || (item.group ? item.group.includes($route.path) : false))}" v-for="(item, index) in navList" :key="index">
                        <div class="title" @click="navClick(item)">
                            <span class="iconfont" :class="item.icon"></span>
                            <p>
                                <span class="font">
                                    {{ item.title }}
                                    <strong class="hot" v-if="item.hot">
                                        <i class="iconfont vant-ali-hot"></i>
                                    </strong>
                                    
                                </span>
                            </p>
                            <van-icon name="arrow-down" class="arrow-down" :class="item.childrenShow ? 'show' : 'hide'" v-if="item.children && item.children.length !== 0" @click.stop="toggleExpand(item)" />
                        </div>
                        <div class="childs" :class="{'close':!item.childrenShow}" v-if="item.children && item.children.length !== 0">
                            <div class="child-item" :class="{'active':($route.path===citem.link || (citem.group ? citem.group.includes($route.path) : false))}" v-for="(citem, cindex) in item.children" :key="cindex" @click="subNavClick(citem)">
                                <div class="child-title">
                                    <div class="dot"></div>
                                    <div class="title-cnt">
                                        <p>
                                            {{ citem.title }}
                                            <span v-if="citem.suffix">{{ citem.suffix }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            iprUrl:'',
            navSrc: require('@/assets/images/navMenu.png'),
            navMenuCheck: require('@/assets/images/navMenuCheck.png'),
            drawShow:false,
            navList:[
                {
                    icon: 'vant-ali-sjcrz',
                    title: '文件/数据认证',
                    childrenShow:true,
                    group:['/time/ApplyTime','/time/ApplyResult','/file/ProtectFile','/file/FileDetail'],
                    children: [
                        {
                            title: '申请文件/数据认证',
                            link: '/time/ApplyTime',
                            group:['/time/ApplyTime','/time/ApplyResult']
                        },
                        {
                            title: '已认证文件',
                            link: '/file/ProtectFile',
                            group:['/file/ProtectFile','/file/FileDetail']
                        }
                    ]
                },
                {
                    icon: 'vant-ali-zpbqrz',
                    title: '版权（著作权）认证',
                    childrenShow:true,
                    group:['/copyright/index','/copyright/copyrightSecond','/copyright/copyrightThird','/copyright/certifiedWork','/copyright/myDraft','/copyright/copyrightAuthSuccess','/copyright/copyrightAuthDetail'],
                    children: [
                        {
                            title: '申请版权（著作权）认证',
                            link: '/copyright/index',
                            group:['/copyright/index','/copyright/copyrightSecond','/copyright/copyrightThird','/drama/copyrightAuthSuccess']
                        },
                        {
                            title: '已认证作品',
                            link: '/copyright/certifiedWork',
                            group:['/copyright/certifiedWork','/copyright/copyrightAuthDetail']
                        },
                        {
                            title: '作品草稿箱',
                            link: '/copyright/myDraft',
                            group:['/copyright/myDraft']
                        }
                    ]
                },
                {
                    icon: 'vant-ali-kexinshijianchuoyanzheng',
                    color: '#545454',
                    title: '可信时间戳验证',
                    link: '/verify/Index',
                },
                {
                    icon: 'vant-ali-gerenzhongxin',
                    color: '#545454',
                    title: '个人中心',
                    link: '/mine/MyInfo',
                },
            ]
        };
    },

    components: {},

    computed: {
        ...mapState({
            draftBoxCount: (state) => state.app.draftBoxCount,
            dramaBoxCount: (state) => state.app.dramaBoxCount,
            parentIframe: (state) => state.app.parentIframe,
        }),
    },

    watch:{
        draftBoxCount (val) {
            this.updateDraftBoxCountCommon(val)
        },
        dramaBoxCount (val) {
            this.updateDramaBoxCountCommon(val)
        },
        '$route'() {
            this.updateDraftBoxCount()
            this.updateDramaBoxCount()
        },
    },
    created() {
        this.iprUrl=window.location.protocol+"//"+window.location.host;
        this.updateDraftBoxCount()
        this.updateDramaBoxCount()
        let {parentIframe} =this
        if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS'){
            this.navList.splice(-2);
        }
    },

    mounted() {},

    methods: {
        ...mapActions({
            updateDraftBoxCount: 'app/updateDraftBoxCount',
            updateDramaBoxCount: 'app/updateDramaBoxCount',
        }),
        addSuffix(path,countText){
            let index=this.navList.findIndex((item)=>{
                return item.group.includes(path)
            })
            let index2=this.navList[index].children.findIndex((item) => {
                return item.link === path
            })
            this.navList[index].children[index2].suffix=countText
        },
        // 通用更新左侧草稿箱数
        updateDraftBoxCountCommon (val) {
            if (val || val === 0) {
                let count = val > 999 ? '999+' : val
                this.addSuffix('/copyright/myDraft', val === 0 ? '' : `(${count})`)
            }
        },
        // 通用更新已认证数的方法
        updateDramaBoxCountCommon (val) {
            if (val || val === 0) {
                let count = val > 999 ? '999+' : val
                this.addSuffix('/copyright/certifiedWork', val === 0 ? '' : `(${count})`)
            }
        },
        // copy() {
        //     var clipboard = new this.Clipboard('.share')
        //     var that = this
        //     clipboard.on('success', (e) => {
        //         // console.log('复制成功')
        //         // 释放内存
        //         that.$toast({
        //             icon:'passed',
        //             className:'mytoast',
        //             type:'success',
        //             message:'链接复制成功,快去粘贴给好友吧！'
        //         })
        //         clipboard.destroy()
        //     })
        //     clipboard.on('error', (e) => {
        //         // 不支持复制
        //         console.log('该浏览器不支持自动复制')
        //         that.$toast('该浏览器不支持自动复制')
        //         // 释放内存
        //         clipboard.destroy()
        //     })
        // },
        getContainer(){
            return document.querySelector('.layout');
        },
        changeShow(){
            this.drawShow=!this.drawShow;
        },
        toggleExpand(item){
            item.childrenShow = !item.childrenShow
        },
        navClick(item){
            if (item.onClick) {
                item.onClick()
            } else {
                if (item.children && item.children.length > 0) {
                    item.childrenShow = true;//展开
                    //自动选中子集中第一个
                    this.subNavClick(item.children[0])
                }else{
                    this.$router.push({
                        path: item.link
                    })
                }
            }
            this.drawShow=false;
        },
        subNavClick(item){
            if (item.onClick) {
                item.onClick()
            } else {
                this.$router.push({
                    path: item.link
                })
            }
            this.drawShow=false;
        },
        
    },
};
</script>
<style lang="less" scoped>
.header{
    height: 47px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    background: #FFF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    h1{
        flex:1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        img{
            height: 30px;
        }
    }
    h2{
        flex:1;
        text-align: center;
        font-size: 14px;
        color:#333;
        font-weight: bold;
    }
    .share{
        flex:1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        img{
            width:14px;
            height: 14px;
        }
    }
    .navBar{
        display: flex;
        img {
            width: 20px;
            height: 20px;
        }
        span{
            i{
                font-size: 24px;
            }
        }
        .open {
            color: #1F5EFF;
        }
    }
}
</style>
<style lang="less">
.mytoast{
    width:230px !important;
    padding: 10px !important;
}
.navOverlay{
    top: 47px !important;
    right: 0;
    height: calc(100% - 47px);
}
.van-popup.navSlide{
    top: calc(50% + 23px);
    left: 0;
    height: calc(100% - 47px);
    .sildeMenu{
        padding: 12px;
        .menu{
            .menu-item{
                margin-bottom: 5px;
                .title {
                    display: flex;
                    align-items: center;
                    height: 40px;
                    cursor: pointer;
                    position: relative;
                    .iconfont {
                        width: 20px;
                        height: 20px;
                        flex-shrink: 0;
                        margin-left: 8px;
                        margin-right: 8px;
                        font-size: 20px;
                        color: #333;
                    }
                    p {
                        flex: 1;
                        font-size: 12px;
                        font-weight: bold;
                        color: #333;
                        position: relative;
                        margin-right: 8px;
                        .font{
                            position: relative;
                            .hot{
                                position: absolute;
                                right: -26px;
                                top: -13px;
                                .vant-ali-hot{
                                    font-size: 12px;
                                    color: #FF384F !important;
                                    margin: 0;
                                }
                            }
                        }
                    }
                    .arrow-down {
                        flex-shrink: 0;
                        width: 20px;
                        height: 20px;
                        font-size: 12px;
                        transition: all 0.2s ease-in-out;
                        margin-right: 8px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #333;
                        font-weight: bold;
                        &.hide {
                            transform: rotate(180deg);
                        }
                    }
                }
                .childs{
                    max-height: 1000px;
                    position: relative;
                    transition: all 0.2s ease-in-out;
                    .child-item{
                        position: relative;
                        margin-bottom: 5px;
                        z-index: 1;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        .child-title{
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            .dot{
                                width: 20px;
                                height: 20px;
                                flex-shrink: 0;
                                margin-left: 8px;
                                margin-right: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                &::before {
                                    margin-right:1px;
                                    content:'';
                                    display:flex;
                                    width: 5px;
                                    height: 5px;
                                    border-radius: 50%;
                                    background: #BED3FF;
                                    flex-shrink: 0;
                                }
                            }
                            .title-cnt {
                                display: flex;
                                align-items: center;
                                height: 30px;
                                flex: 1;
                                p {
                                    margin-right: 4px;
                                    color: #666;
                                    font-size: 12px;
                                    position: relative;
                                    font-weight: normal;
                                }
                                .count {
                                    color: #666;
                                    font-size: 14px;
                                    position: relative;
                                    font-weight: normal;
                                    font-style: normal;
                                    flex: 1;
                                    text-align: right;
                                    padding-right: 17px;
                                }
                            }
                        }
                        &.active{
                            .child-title{
                                .title-cnt{
                                    p{
                                        color: #0047FF;
                                    }
                                }
                            }
                        }
                    }
                    &::after {
                        content: '';
                        display: flex;
                        position: absolute;
                        width: 1px;
                        background: #BED3FF;
                        left: 17px;
                        top: 14px;
                        bottom: 14px;
                    }
                    &.close{
                        max-height: 0;
                        overflow: hidden;
                    }
                }
                &.active{
                    .title {
                        box-shadow: 2px 8px 20px 0px rgba(81,118,185,0.17);
                        border-radius: 10px;
                        .iconfont,.arrow-down {
                            color: #1F5EFF!important;
                        }
                        p {
                            color: #1F5EFF!important;
                        }
                        &::after {
                            width: 3px;
                            height: 24px;
                            content: '';
                            position: absolute;
                            top: 50%;
                            left: 2px;
                            background: #1F5EFF;
                            border-top-right-radius: 20px;
                            border-bottom-right-radius: 20px;
                            background-size: contain;
                            transform: translateY(-50%);
                        }
                    }
                }
                
            }
        }
    }
}
</style>
